import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { SafeAreaProvider, useSafeAreaInsets } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';

import { HomePage } from './screens/HomePage';
import { ArtistHubPage } from './screens/ArtistHubPage';
import { CurationCenterPage } from './screens/CurationCenterPage';
import { ProfilePage } from './screens/ProfilePage';
import { ArtistPage } from './screens/ArtistPage';
import ArtworkDetailPage from './screens/ArtworkDetailPage';
import { SearchPage } from './screens/SearchPage';

import { HomeIcon, GalleryIcon, CurationIcon, ProfileIcon } from './components/icons';
import { theme } from './theme/theme';

const Tab = createBottomTabNavigator();
const Stack = createStackNavigator();

const TabNavigator = () => {
  const insets = useSafeAreaInsets();
  
  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarStyle: {
          backgroundColor: theme.colors.surface,
          borderTopWidth: 1,
          borderTopColor: theme.colors.border,
          height: 60 + Math.max(insets.bottom, 0),
          paddingBottom: Math.max(insets.bottom, 8),
          paddingTop: 8,
        },
        tabBarActiveTintColor: theme.colors.primary,
        tabBarInactiveTintColor: theme.colors.textSecondary,
        tabBarLabelStyle: {
          fontSize: 12,
          fontWeight: '500',
          marginTop: 2,
        },
      }}
    >
      <Tab.Screen
        name="Home"
        component={HomePage}
        options={{
          title: '首页',
          tabBarIcon: ({ color }) => (
            <HomeIcon size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Gallery"
        component={ArtistHubPage}
        options={{
          title: '画廊',
          tabBarIcon: ({ color }) => (
            <GalleryIcon size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Curation"
        component={CurationCenterPage}
        options={{
          title: '策展',
          tabBarIcon: ({ color }) => (
            <CurationIcon size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Profile"
        component={ProfilePage}
        options={{
          title: '我的',
          tabBarIcon: ({ color }) => (
            <ProfileIcon size={24} color={color} />
          ),
        }}
      />
    </Tab.Navigator>
  );
};

const AppNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        cardStyle: { backgroundColor: theme.colors.bg },
      }}
    >
      <Stack.Screen name="Main" component={TabNavigator} />
      <Stack.Screen 
        name="ArtistPage" 
        component={ArtistPage}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="ArtworkDetailPage" 
        component={ArtworkDetailPage}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="SearchPage" 
        component={SearchPage}
        options={{
          presentation: 'modal',
        }}
      />
    </Stack.Navigator>
  );
};

export default function App() {
  return (
    <SafeAreaProvider>
      <NavigationContainer>
        <StatusBar style="dark" backgroundColor={theme.colors.surface} />
        <AppNavigator />
      </NavigationContainer>
    </SafeAreaProvider>
  );
}
